import React from 'react';
import { useHistory } from 'react-router';
import { withFirebase } from 'utils/Firebase';
import GoogleSVG from '../../assets/images/icons/google.svg'

const ERROR_CODE_ACCOUNT_EXISTS =
	'auth/account-exists-with-different-credential';

const ERROR_MSG_ACCOUNT_EXISTS = `
  An account with an E-Mail address to
  this social account already exists. Try to login via other methods
   instead and associate your social accounts via
  your account profile page.
`;

export const SignInGoogle = withFirebase((props) => {
	const {
		firebase,
		// popup1,
		setError,
		setRegistered,
		text
	} = props

	const history = useHistory()

	const onSubmit = event => {
		// let newUser
		firebase
			.signInWithGoogle()
			.then(socialAuthUser => {
				firebase
					.user(socialAuthUser.user.uid)
					.set({
						name: socialAuthUser.user.displayName,
						email: socialAuthUser.user.email,
						roles: {},
					});
				// newUser = socialAuthUser.additionalUserInfo.isNewUser
			})
			.then(() => {
				setRegistered && setRegistered(true)
				setError({});
				// (popup1 && newUser) ? popup1() : history.push('/account')
				history.push('/account')
			})
			.catch(err => {
				if (err.code === ERROR_CODE_ACCOUNT_EXISTS) {
					err.message = ERROR_MSG_ACCOUNT_EXISTS;
				}
				setError(err);
			});

		event.preventDefault();
	};

	return (
		<form onSubmit={onSubmit}>
			<button type="submit" className="rn-button-style--2 btn-google">
				<img src={GoogleSVG} alt="google" />
				<span>{ `${text} with Google` }</span>
			</button>
		</form>
	);
})
